<template>
  <v-card>
    <v-card-title>Registrar integración TEF</v-card-title>
    <v-card-text>
      <v-form ref="form">
        <v-row>
          <v-col cols="12" md="9">
            <v-select
              v-model="form.IdCompania"
              :items="filteredClients"
              item-text="text"
              item-value="IdCompania"
              label="Compañía"
              prepend-inner-icon="mdi-sitemap"
              :rules="[requiredRule]"
            >
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-text-field
                      v-model="search"
                      hide-details
                      placeholder="Buscar compañía"
                      prepend-inner-icon="mdi-magnify"
                    />
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" md="3" class="d-flex align-center">
            <v-btn
              block
              dark
              style="background-color: rgb(204 33 40); color: white !important;"
              @click="save"
            >
              REGISTRAR
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-alert type="info" text>
        El archivo Excel definirá el código de terminal, el establecimiento y
        la primera integración.
      </v-alert>

      <v-alert v-show="successAlert" type="success" text>
        {{ message }}
      </v-alert>
      <v-alert v-show="errorAlert" type="error" text>
        {{ message }}
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'RegisterTerminalTef',

  data () {
    return {
      search: '',
      successAlert: false,
      errorAlert: false,
      message: '',
      form: {
        IdCompania: null
      },
      requiredRule: value => (
        value === null ||
        value === undefined ||
        value === ''
          ? 'Este campo es obligatorio'
          : true
      )
    }
  },

  computed: {
    clients () {
      return (
        this.$store.state.invoice.listClients.Mensaje || []
      )
        .filter(client => client.Activo === 1)
        .map(client => ({
          ...client,
          text: `[${client.IdCompania}] ${client.NombreCompania}`
        }))
    },

    filteredClients () {
      const configuredCompanyIds = (
        this.$store.state.credentialsTef.listTerminals || []
      ).map(terminal => Number(terminal.IdCompania))

      const availableClients = this.clients.filter(client =>
        !configuredCompanyIds.includes(Number(client.IdCompania))
      )

      if (!this.search) {
        return availableClients
      }

      return availableClients.filter(client =>
        client.text.toLowerCase().includes(this.search.toLowerCase())
      )
    }
  },

  async created () {
    await this.$store.dispatch('invoice/getListClients')
    await this.$store.dispatch('credentialsTef/getTerminals')
  },

  methods: {
    async save () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.successAlert = false
      this.errorAlert = false

      try {
        const response = await this.$store.dispatch(
          'credentialsTef/getTerminals'
        )

        const company = this.clients.find(
          client => Number(client.IdCompania) === Number(this.form.IdCompania)
        )
        this.$emit('configure', company)
        this.$refs.form.resetValidation()
      } catch (error) {
        this.message = 'No fue posible cargar las compañías disponibles.'
        this.errorAlert = true
      }
    }
  }
}
</script>
